import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Box, Button, Tooltip } from '@mui/material';
import React from 'react';

export interface ExportCsvButtonProps {
  /** Called when the user clicks the export button. */
  onClick: () => void;
}

/**
 * Download button placed on top of the plot area for CSV export.
 */
export const ExportCsvButton: React.FC<ExportCsvButtonProps> = ({ onClick }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 16,
        right: 16,
        zIndex: 100,
      }}
    >
      <Tooltip title="Exporter les données en CSV" arrow>
        <Button
          variant="outlined"
          color="primary"
          size="small"
          startIcon={<FileDownloadIcon fontSize="small" />}
          onClick={onClick}
          sx={{
            bgcolor: 'background.paper',
            textTransform: 'none',
            fontWeight: 500,
            '&:hover': {
              bgcolor: 'action.hover',
            },
          }}
        >
          CSV
        </Button>
      </Tooltip>
    </Box>
  );
};
